export default __webpack_public_path__ + "static/WHITE_GOLDIOCKS-3859fe21c47b70b11d44ab0ce855209d.jpg";